<template>
  <div class="add-member">
    <van-form @submit="addOrEditMember">
      <van-field 
        v-model="form.receiverName"
        required
        label="姓名" 
        placeholder="请输入姓名" 
        :rules="[{ required: true, message: '' }]" 
      />
      <div class="input-box">
       <van-field 
          v-model="form.mobile" 
          name="mobile" 
          label="手机号" 
          placeholder="请输入手机号"  
          :rules="mobileRules"
          required
        />
        <span class="error-message" v-if="phoneErrorMessage">{{ phoneErrorMessage }}</span>
      </div>
      <van-field
        v-model="form.nationality" 
        required
        readonly
        clickable
        placeholder="请选择国籍"
        @click="showNationalityPicker = true" 
        label="国籍"
        :rules="[{ required: true, message: '' }]"
      />
      <van-popup v-model="showNationalityPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="columns"
          @confirm="(value) => onConfirm(value, 'nationality')"
          @cancel="showNationalityPicker = false"
        />
      </van-popup>
      <van-field  
        v-model="form.idTypeName" 
        required
        readonly
        clickable
        name="picker"
        placeholder="请选择证件类型"
        @click="showIdTypePicker = true" 
        label="证件类型" 
        :rules="[{ required: true, message: '' }]"
      />
      <van-popup v-model="showIdTypePicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="idTypeOptions"
          @confirm="(value) => onConfirm(value, 'idType')"
          @cancel="showIdTypePicker = false"
        />
      </van-popup>
      <div class="input-box">
      <van-field 
        v-model="form.idNumber" 
        name="idNumber" 
        label="证件号码" 
        placeholder="请输入证件号码" 
        :rules="idNumberRules"
        required
        />
        <span class="error-message" v-if="idNumberErrorMessage">{{ idNumberErrorMessage }}</span>
      </div>
      <van-field 
      type="textarea"
      v-model="form.address"
      label="地址" 
      placeholder="请输入地址"
      rows="3"
      />
      <div class="btn">
        <van-button color="#FF7C6D" round type="primary" block native-type="submit">{{ type === 'edit' ? '修改' : '添加' }}</van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
  import checkIdCard from '@/utils/checkIdCard'
  import { countryList } from '@/utils/countryList.js';
  import api from "@/utils/api.js"
  export default{
    data() {
      return {
        pattern: /^1[3-9]\d{9}$/,
        type: '',
        form: {
          receiverName: '',
          nationality: '',
          mobile: '',
          idType: '',
          idTypeName: '',
          idNumber: '',
          address: '',
        },
        phoneErrorMessage: '',
        idNumberErrorMessage: '',
        columns: countryList,
        value: '',
        showNationalityPicker: false,
        showIdTypePicker: false,
        idTypeOptions: [
          {text: '身份证', value: '1' },
          {text: '港澳居民来往内地通行证', value: '4' },
          {text: '台湾居民来往大陆通行证', value: '5' },
          {text: '中国护照', value: '6' },
          {text: '外国护照', value: '7' },
        ],
      }
    },
    computed: {
      // 手机号校验规则
      mobileRules() {
        return [
          { 
            required: true,
            validator: this.validateMobile,
            message: '',
          }
        ]
      },
      // 证件号码校验规则
      idNumberRules() {
        return [
          { 
            required: true,
            message: '',
            validator: this.validateIdNumberField
          }
        ]
      }
    },
    created() {
      this.type = this.$route.query.type
      if(this.type === 'edit') {
        const member = JSON.parse(sessionStorage.getItem('member'))
        const idTypeObj = this.idTypeOptions.find(item => item.value == member.idType)
        if(idTypeObj) {
          member.idTypeName = idTypeObj.text || ''
        } else {
          member.idTypeName = ''
        }
        this.form = member
      }
    },
    methods: {
      // 手机号校验
      validateMobile(value) {
        if (!value) {
          return Promise.reject('请输入手机号');
        }
        if (!/^1[3-9]\d{9}$/.test(value)) {
          this.phoneErrorMessage = '请输入正确的手机号格式'
          return Promise.reject('请输入正确的手机号格式');
        }
        this.phoneErrorMessage = ''
        return Promise.resolve();
      },
      
      // 证件号码字段校验
      validateIdNumberField(value) {
        if (!value) {
          return Promise.reject('请输入证件号码');
        }
        if (!this.validateIdNumber(value)) {
          this.idNumberErrorMessage = '请输入正确的证件号码格式'
          return Promise.reject('请输入正确的证件号码格式');
        }
        this.idNumberErrorMessage = ''
        return Promise.resolve();
      },
      
      onConfirm(value, type) {
        // 获取选中的对象 
        this.showNationalityPicker = false
        this.showIdTypePicker = false
        if(type === 'nationality') {
          this.form.nationality = value.text
          this.form.code = value.value
        } else if(type === 'idType') {
          this.form.idTypeName = value.text
          this.form.idType = value.value
        }
      },
      validateIdNumber(val) {
        if(this.form.idType === '1') {
          return checkIdCard(val)
        } else {
          return true
        }
      },
      // 添加/编辑成员
      addOrEditMember() {
        api.addOrUpdateMember({...this.form, cuswebuserid: this.$route.query.userId}).then((res) => {
          let data = res.data
          if(data.returnCode === '00') {
            this.$toast("操作成功");
            setTimeout(() => {
              this.$router.back()
            }, 500)
            return
          }
          this.$toast(data.returnMsg)
        })
      }
    }
  }
</script>
<style lang="scss" scoped>
  .add-member {
    padding: 6px;
    background-color: #fefefe;
    .btn {
      margin-top: 40px;
      padding: 0 24px;
      box-sizing: border-box;
    }
    .input-box {
      position: relative;
    }
    .input-box::after {
      position: absolute;
      box-sizing: border-box;
      content: ' ';
      pointer-events: none;
      right: 0.426667rem;
      bottom: 0;
      left: 0.426667rem;
      border-bottom: 0.026667rem solid #ebedf0;
      -webkit-transform: scaleY(.5);
      transform: scaleY(.5);
      }
    .error-message {
      color: #ee0a24;
      font-size: 12px;
      position: absolute;
      bottom: 2px;
      left: 9.5em;
      z-index: 10;
    }
  }
</style>